<template>
    <div class="content-layout">
        <v-img
            dark
            :src="heroImage"
            :height="height"
            :key="heroImage"
            class="page-hero"
            :class="{ 'page-hero--home': home }"
            :style="heroStyle"
        >
            <div class="page-hero__shade"></div>
            <v-container fluid fill-height class="page-hero__content">
                <v-row align="center" justify="center">
                    <v-col cols="12" :md="md" :lg="lg" :xl="xl">
                        <v-chip
                            v-if="eyebrow"
                            label
                            color="secondary"
                            text-color="primary"
                            class="font-weight-bold mb-5"
                        >
                            <v-icon v-if="icon" left color="primary">{{ icon }}</v-icon>
                            {{ eyebrow }}
                        </v-chip>
                        <h1 class="display-2 font-weight-bold mb-4">{{ title }}</h1>
                        <p
                            v-if="subtitle"
                            class="headline font-weight-light mb-6 page-hero__copy"
                        >
                            {{ subtitle }}
                        </p>
                        <div v-if="$slots['hero-actions']" class="d-flex flex-wrap">
                            <slot name="hero-actions"></slot>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-img>
        <div id="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    // Module
    export default {
        name: "content-layout",
        props: {
            eyebrow: {
                type: String,
                default: null
            },
            icon: {
                type: String,
                default: null
            },
            title: {
                type: String,
                required: true
            },
            subtitle: {
                type: String,
                default: null
            },
            image: {
                type: String,
                default: null
            },
            height: {
                type: [Number, String],
                default: 400
            },
            mobileHeight: {
                type: [Number, String],
                default: 320
            },
            home: {
                type: Boolean,
                default: false
            },
            md: {
                type: [Number, String],
                default: 10
            },
            lg: {
                type: [Number, String],
                default: 8
            },
            xl: {
                type: [Number, String],
                default: 7
            }
        },
        computed: {
            heroImage() {
                return this.image || this.$store.state.data.page_header_img || require("./../../assets/img/hero.jpg");
            },
            heroStyle() {
                const mobileHeight = typeof this.mobileHeight === "number" ? this.mobileHeight + "px" : this.mobileHeight;
                return {
                    "--page-hero-mobile-height": mobileHeight
                };
            }
        }
    };
</script>

<style scoped>
    .page-hero {
        position: relative;
    }

    .page-hero__shade {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background:
            linear-gradient(90deg, rgba(13, 15, 18, 0.95) 0%, rgba(13, 15, 18, 0.76) 50%, rgba(13, 15, 18, 0.28) 100%),
            linear-gradient(0deg, rgba(13, 15, 18, 0.8) 0%, rgba(13, 15, 18, 0.04) 54%);
    }

    .page-hero--home .page-hero__shade {
        background:
            linear-gradient(90deg, rgba(13, 15, 18, 0.95) 0%, rgba(13, 15, 18, 0.78) 48%, rgba(13, 15, 18, 0.28) 100%),
            linear-gradient(0deg, rgba(13, 15, 18, 0.85) 0%, rgba(13, 15, 18, 0.04) 54%);
    }

    .page-hero__content {
        position: relative;
        z-index: 1;
    }

    .page-hero__copy {
        max-width: 760px;
        line-height: 1.45;
    }

    #content {
        position: relative;
    }

    @media (max-width: 599px) {
        .page-hero {
            height: auto !important;
            min-height: var(--page-hero-mobile-height) !important;
        }

        .page-hero h1 {
            font-size: 2rem !important;
            line-height: 1.15;
        }

        .page-hero__copy {
            font-size: 1.08rem !important;
        }
    }
</style>
